/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { useVideo } from '@api/hooks';
import { ContentModuleModal, VideoField } from '@molecules';

import Form from '../Form';

import { FORM_FIELD } from './constants';
import Item from './Item';
import VideoList from './VideoList';

const VideoHeroModal = ({ visible, onSubmit, hide, previewImg, onDelete, initialValues: data, errors }) => {
  const [form] = Form.useForm(FORM_FIELD);

  const videoQuery = useVideo({ id: data?.videoId });
  React.useEffect(() => {
    if (visible && videoQuery.status === 'success') {
      form.setFieldsValue({ [FORM_FIELD.VIDEOS.name]: videoQuery.data });
    }
  }, [videoQuery.video, videoQuery.data, videoQuery.status, form, visible]);

  const initialValues = React.useMemo(() => form.deserialize(data), [data, form]);

  const handleClose = () => {
    form.resetFields();
    hide();
  };

  const handleSubmit = (values) => {
    onSubmit(values);
    handleClose();
  };

  const handleDeleteVideo = () => form.setFieldsValue({ [FORM_FIELD.VIDEOS.name]: undefined });

  return (
    <ContentModuleModal
      okText={onDelete ? 'UPDATE CHANGES' : 'ADD HERO VIDEO'}
      subtitle="Choose hero video for main landing site."
      heroImageSrc={previewImg}
      onCancel={handleClose}
      onSubmit={form.submit}
      onDelete={onDelete}
      title="Hero Video"
      visible={visible}
      errors={errors}
    >
      <Form
        form={form}
        layout="vertical"
        wrapperCol={{ span: 24 }}
        initialValues={initialValues}
        onSerializedFinish={handleSubmit}
      >
        <VideoField {...FORM_FIELD.VIDEOS} />
        <Form.WithFieldValue name={FORM_FIELD.VIDEOS.name}>
          {(value) => value && <VideoList videoId={value?.id?.split('_')[0] || value} onDelete={handleDeleteVideo} />}
        </Form.WithFieldValue>
      </Form>
    </ContentModuleModal>
  );
};

VideoHeroModal.Item = Item;

export default VideoHeroModal;
